import React from 'react';

function AboutCiteUs() {
  return (
    <div>
      {' '}
      <h2>How to cite us</h2>
      <p>
        If you use DISGENET in your work, please cite our URL{' '}
        <a href="https://www.disgenet.com/" target="_blank" rel="noreferrer">
          {'https://www.disgenet.com'}
        </a>{' '}
        and our latest publication:
      </p>
      <p>
        DISGENET: Accelerating Data-Driven Discovery in Disease Genomics and Therapeutic Development.
      </p>
      <p>
        Janet Pinero, Javier Corvi, Natalia Rykova, Anna Guillem, Amelia Martinez, Jaione Telleria Zufiaur, Ivo Rivetta, Sarah Holmes, Mariandrea Del Boccio, Daniel Shapoval, Macarena de Sarasqueta Szneiderowicz, Felix Slager, Ferran Sanz, Laura I Furlong.{' '}
      </p>
      <p>
        bioRxiv 2026.01.05.697749; doi:{' '}
        <a href="https://www.biorxiv.org/content/10.64898/2026.01.05.697749v1" target="_blank" rel="noreferrer">
          {'DISGENET: Accelerating Data-Driven Discovery in Disease Genomics and Therapeutic Development'}
        </a>
      </p>
    </div>
  );
}

export default AboutCiteUs;
